import React, { useContext } from 'react';
import type { ICommonDialogContext } from '../base/dialog/dialog';

/**
 * The app's dialogs, as the common `show` / `hide` pair (`useCommonDialogContext`). The support and
 * provider apps each have their own dialog provider with different method names; `RosterScreen` is
 * handed the bridged one by its app and provides it here, so the screens below never know which
 * app they are in.
 */
export const RosterDialogContext = React.createContext<ICommonDialogContext | undefined>(undefined);

export function useRosterDialog(): ICommonDialogContext {
    const dialog = useContext(RosterDialogContext);
    if (!dialog) {
        throw new Error('The Roster screens need the dialog context that RosterScreen provides.');
    }
    return dialog;
}
